export const INVALIDATE_CONNECTED_ACCOUNTS = 'INVALIDATE_CONNECTED_ACCOUNTS';